import * as React from 'react';
import { useState, useEffect, useCallback, useRef } from "react";
import PropTypes from 'prop-types';

import SaveIcon from '@mui/icons-material/Save';

import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputBase from '@mui/material/InputBase';
import { TextField, Button, FormControl, makeStyles } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";


import ConfigurationViewService from '../../services/configurationview.service';
import TableViewService from '../../services/tableview.service';
import AuditTrailViewService from '../../services/audittrailview.service';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};



function SaveChangesDialog(props) {

  const [open, setOpen] = useState(false);
  const [wrongValue, setWrongValue] = useState(false);

  const [message, setMessage] = useState();

  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openInProgressdialog, setOpenInProgressdialog] =useState(false);
  const [openFaildialog, setOpenFaildialog] = useState(false);

  const [saveData, setSaveData] = useState(false);
  const[alarmConfigData, setAlarmTagData] = React.useState(props.alarmConfigData);
  const[tagNamesInWriteConfig, setTagNamesInWriteConfig] = React.useState([]);


  const [openRemarkBlnkMsg, setOpenRemarkBlnkMsg] = useState(false);
  const [password, setPassword] = useState('');

  // get all data from writeconfig collection
  useEffect(() =>{

    async function getAllRowsData()  {
      try {

        let dashboardName = "WriteConfig"

        const response = await ConfigurationViewService.getAllRowsData(dashboardName);
        if (response){
          setTagNamesInWriteConfig(response.data.map((item) => item.TagName)); 
          //console.log(response.data);
        }
        
        
      } catch (error) {
        console.log(error);

      }
    };
    getAllRowsData();


  }, []);

  
 
  const handleClickSaveChanges = () => { 
    setSaveData(true);
  };

  
  const handleClose = () => {
    setOpen(false);
    setWrongValue(false);
    setOpenRemarkBlnkMsg(false);
  };

  const handleSuccessClose = () => {
    setOpenSuccessDialog(false);
    props.success(true);
  };

  const handleInProgressClose = (reason) => {
    if (reason !== 'backdropClick') {
      //setOpenInProgressdialog(false);
    }
    
  };

  const handleFailedClose = () => {
    setOpenFaildialog(false);
  };


  const [writeInProgress, setWriteInProgress] = useState(false);
  const [writeHiHiInProgress, setWriteHiHiInProgress] = useState(false);
  const [writeHighInProgress, setWriteHighInProgress] = useState(false);
  const [writeLowInProgress, setWriteLowInProgress] = useState(false);
  const [writeLoLoInProgress, setWriteLoLoInProgress] = useState(false);

  const [ReadRequest, setReadRequest] = useState(false);

  const isMounted = useRef(true); // Track if the component is mounted
  useEffect(() => {
    isMounted.current = true; // Component mounted
    return () => {
      isMounted.current = false; // Cleanup when the component unmounts
    };
  }, [ReadRequest]);

  // operation depend upon WriteStatus result from python code, if success or fail proceed accordingly
  // it is checking perodically
  useEffect(() =>{
    async function readWriteConfigCollection(){
      try {

        ////////////////////////////////////////////////////////////////
        //If field tag is assigned to process value
        if(props.tagDetails.TagType !== 'SystemTag' && writeInProgress === true)
        {
          const TagName = props.writeData.TagName;
          let responseData12 = null;
          try {
            let response12 = await TableViewService.readTag(TagName);
            // Only 200 responses
            if (response12.status === 200 && response12.data) {
              responseData12 = response12.data; // object from
            }

          } catch (error) {
            // Any API error (500 / network) → treat as FAIL
            console.log("API Error:", error);

            responseData12 = {WriteStatus: "Fail"};
          }

          // Handle all cases centrally
          if (responseData12?.WriteStatus === "Success") {

            let auditTrailData = {
              EventStatus: props.writeData.EventStatus,
              ActivityType: 'Parameter Value Change',
              Remark: props.writeData.Remark,
              UserName: props.writeData.email,
              Role: props.writeData.role,
              TimeStamp: new Date(),
              Activity: `For parameter - ${props.writeData.TagName} setpoint was modified from '${props.writeData.OldProcessValue}' to '${responseData12.NewValue}'`
            };
            if(props.writeData.EventStatus === "Enabled"){
              let dashboardName = "AuditTrailLog";
              const response2 = await AuditTrailViewService.createRow(dashboardName, auditTrailData);
              if(response2){
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(true);
                setMessage("Parameter value updated Successfully");
                setSaveData(false);
                setOpen(false);
                setWriteInProgress(false);

              }

            }else{
              setOpenInProgressdialog(false);
              setOpenSuccessDialog(true);
              setMessage("Parameter value updated Successfully");
              setSaveData(false);
              setOpen(false);
              setWriteInProgress(false);

            }

          } else if (responseData12?.WriteStatus === "Fail") {

            // Covers BOTH Redis fail + API fail
            if(props.writeData.EventStatus === "Enabled"){

              let auditTrailData = {
                EventStatus: "Disabled",
                ActivityType: 'Parameter Value Change',
                Remark: props.writeData.Remark,
                UserName: props.writeData.email,
                Role: props.writeData.role,
                TimeStamp: new Date(),
                Activity: `For parameter - ${props.writeData.TagName} setpoint modification failed.`
              };

              let dashboardName = "AuditTrailLog";
              const response2 = await AuditTrailViewService.createRow(dashboardName, auditTrailData);
              if(response2){
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(false);
                setOpenFaildialog(true);
                setMessage("Write to parameter failed. Either no change in value or device/server is down");
                setSaveData(false);
                setOpen(false);
                setWriteInProgress(false);

              }else{
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(false);
                setOpenFaildialog(true);
                setMessage("Write to parameter failed. Either no change in value or device/server is down");
                setSaveData(false);
                setOpen(false);
                setWriteInProgress(false);

              }

            }

          } else if (responseData12?.WriteStatus === "InProgress") {

            // Keep polling flag true
            setWriteInProgress(true);

          } else {
            //Fallback safety
            setOpenInProgressdialog(false);
            setOpenSuccessDialog(false);
            setOpenFaildialog(true);
            setMessage("Unexpected response from server");
            setOpen(false);
            setWriteInProgress(false);
          }
        }

        // If system tag is not assigned and field tag is asssigned for alarma setpoints
        
        if (props.alarmConfigData.TagTypeHiHiSP !== 'SystemTag' && writeHiHiInProgress === true)
        {
          const TagName = props.alarmConfigData.TagNameHiHiSP;
          let responseData12 = null;
          try {
            let response12 = await TableViewService.readTag(TagName);
            // Only 200 responses
            if (response12.status === 200 && response12.data) {
              responseData12 = response12.data; // object from
            }

          } catch (error) {
            // Any API error (500 / network) → treat as FAIL
            console.log("API Error:", error);

            responseData12 = {WriteStatus: "Fail"};
          }

          // Handle all cases centrally
          if (responseData12?.WriteStatus === "Success") {

            let auditTrailData = {
              EventStatus: props.writeData.EventStatus,
              ActivityType: 'Parameter Value Change',
              Remark: props.writeData.Remark,
              UserName: props.writeData.email,
              Role: props.writeData.role,
              TimeStamp: new Date(),
              Activity: `For parameter - ${props.alarmConfigData.TagNameHiHiSP} HiHi setpoint was modified from '${props.writeData.OldHiHiSP}' to '${responseData12.NewValue}'`
            };
            if(props.writeData.EventStatus === "Enabled"){
              let dashboardName = "AuditTrailLog";
              const response2 = await AuditTrailViewService.createRow(dashboardName, auditTrailData);
              if(response2){
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(true);
                setMessage("Parameter value updated Successfully");
                setSaveData(false);
                setOpen(false);
                setWriteHiHiInProgress(false);

              }

            }else{
              setOpenInProgressdialog(false);
              setOpenSuccessDialog(true);
              setMessage("Parameter value updated Successfully");
              setSaveData(false);
              setOpen(false);
              setWriteHiHiInProgress(false);

            }

          } else if (responseData12?.WriteStatus === "Fail") {

            // Covers BOTH Redis fail + API fail
            if(props.writeData.EventStatus === "Enabled"){

              let auditTrailData = {
                EventStatus: "Disabled",
                ActivityType: 'Parameter Value Change',
                Remark: props.writeData.Remark,
                UserName: props.writeData.email,
                Role: props.writeData.role,
                TimeStamp: new Date(),
                Activity: `For parameter - ${props.alarmConfigData.TagNameHiHiSP} HiHi setpoint modification failed.`
              };

              let dashboardName = "AuditTrailLog";
              const response2 = await AuditTrailViewService.createRow(dashboardName, auditTrailData);
              if(response2){
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(false);
                setOpenFaildialog(true);
                setMessage("Write to parameter failed. Either no change in value or device/server is down");
                setSaveData(false);
                setOpen(false);
                setWriteHiHiInProgress(false);

              }else{
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(false);
                setOpenFaildialog(true);
                setMessage("Write to parameter failed. Either no change in value or device/server is down");
                setSaveData(false);
                setOpen(false);
                setWriteHiHiInProgress(false);

              }

            }

          } else if (responseData12?.WriteStatus === "InProgress") {

            // Keep polling flag true
            setWriteHiHiInProgress(true);

          } else {
            //Fallback safety
            setOpenInProgressdialog(false);
            setOpenSuccessDialog(false);
            setOpenFaildialog(true);
            setMessage("Unexpected response from server");
            setOpen(false);
            setWriteHiHiInProgress(false);
          }
        }
        else if(props.alarmConfigData.TagTypeHighSP !== 'SystemTag' && writeHiHiInProgress === false && writeHighInProgress === true)
        {
          const TagName = props.alarmConfigData.TagNameHighSP;
          let responseData12 = null;
          try {
            let response12 = await TableViewService.readTag(TagName);
            // Only 200 responses
            if (response12.status === 200 && response12.data) {
              responseData12 = response12.data; // object from
            }

          } catch (error) {
            // Any API error (500 / network) → treat as FAIL
            console.log("API Error:", error);

            responseData12 = {WriteStatus: "Fail"};
          }

          // Handle all cases centrally
          if (responseData12?.WriteStatus === "Success") {

            let auditTrailData = {
              EventStatus: props.writeData.EventStatus,
              ActivityType: 'Parameter Value Change',
              Remark: props.writeData.Remark,
              UserName: props.writeData.email,
              Role: props.writeData.role,
              TimeStamp: new Date(),
              Activity: `For parameter - ${props.alarmConfigData.TagNameHighSP} High setpoint was modified from '${props.writeData.OldHighSP}' to '${responseData12.NewValue}'`
            };
            if(props.writeData.EventStatus === "Enabled"){
              let dashboardName = "AuditTrailLog";
              const response2 = await AuditTrailViewService.createRow(dashboardName, auditTrailData);
              if(response2){
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(true);
                setMessage("Parameter value updated Successfully");
                setSaveData(false);
                setOpen(false);
                setWriteHighInProgress(false);

              }

            }else{
              setOpenInProgressdialog(false);
              setOpenSuccessDialog(true);
              setMessage("Parameter value updated Successfully");
              setSaveData(false);
              setOpen(false);
              setWriteHighInProgress(false);

            }

          } else if (responseData12?.WriteStatus === "Fail") {

            // Covers BOTH Redis fail + API fail
            if(props.writeData.EventStatus === "Enabled"){

              let auditTrailData = {
                EventStatus: "Disabled",
                ActivityType: 'Parameter Value Change',
                Remark: props.writeData.Remark,
                UserName: props.writeData.email,
                Role: props.writeData.role,
                TimeStamp: new Date(),
                Activity: `For parameter - ${props.alarmConfigData.TagNameHighSP} High setpoint modification failed.`
              };

              let dashboardName = "AuditTrailLog";
              const response2 = await AuditTrailViewService.createRow(dashboardName, auditTrailData);
              if(response2){
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(false);
                setOpenFaildialog(true);
                setMessage("Write to parameter failed. Either no change in value or device/server is down");
                setSaveData(false);
                setOpen(false);
                setWriteHighInProgress(false);

              }else{
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(false);
                setOpenFaildialog(true);
                setMessage("Write to parameter failed. Either no change in value or device/server is down");
                setSaveData(false);
                setOpen(false);
                setWriteHighInProgress(false);

              }

            }

          } else if (responseData12?.WriteStatus === "InProgress") {

            // Keep polling flag true
            setWriteHighInProgress(true);

          } else {
            //Fallback safety
            setOpenInProgressdialog(false);
            setOpenSuccessDialog(false);
            setOpenFaildialog(true);
            setMessage("Unexpected response from server");
            setOpen(false);
            setWriteHighInProgress(false);
          }
        }
        else if(props.alarmConfigData.TagTypeLowSP !== 'SystemTag' && writeHiHiInProgress === false && writeHighInProgress === false && writeLowInProgress === true)
        {
          const TagName = props.alarmConfigData.TagNameLowSP;
          let responseData12 = null;
          try {
            let response12 = await TableViewService.readTag(TagName);
            // Only 200 responses
            if (response12.status === 200 && response12.data) {
              responseData12 = response12.data; // object from
            }

          } catch (error) {
            // Any API error (500 / network) → treat as FAIL
            console.log("API Error:", error);

            responseData12 = {WriteStatus: "Fail"};
          }

          // Handle all cases centrally
          if (responseData12?.WriteStatus === "Success") {

            let auditTrailData = {
              EventStatus: props.writeData.EventStatus,
              ActivityType: 'Parameter Value Change',
              Remark: props.writeData.Remark,
              UserName: props.writeData.email,
              Role: props.writeData.role,
              TimeStamp: new Date(),
              Activity: `For parameter - ${props.alarmConfigData.TagNameLowSP} Low setpoint was modified from '${props.writeData.OldLowSP}' to '${responseData12.NewValue}'`
            };
            if(props.writeData.EventStatus === "Enabled"){
              let dashboardName = "AuditTrailLog";
              const response2 = await AuditTrailViewService.createRow(dashboardName, auditTrailData);
              if(response2){
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(true);
                setMessage("Parameter value updated Successfully");
                setSaveData(false);
                setOpen(false);
                setWriteLowInProgress(false);

              }

            }else{
              setOpenInProgressdialog(false);
              setOpenSuccessDialog(true);
              setMessage("Parameter value updated Successfully");
              setSaveData(false);
              setOpen(false);
              setWriteLowInProgress(false);

            }

          } else if (responseData12?.WriteStatus === "Fail") {

            // Covers BOTH Redis fail + API fail
            if(props.writeData.EventStatus === "Enabled"){

              let auditTrailData = {
                EventStatus: "Disabled",
                ActivityType: 'Parameter Value Change',
                Remark: props.writeData.Remark,
                UserName: props.writeData.email,
                Role: props.writeData.role,
                TimeStamp: new Date(),
                Activity: `For parameter - ${props.alarmConfigData.TagNameLowSP} Low setpoint modification failed.`
              };

              let dashboardName = "AuditTrailLog";
              const response2 = await AuditTrailViewService.createRow(dashboardName, auditTrailData);
              if(response2){
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(false);
                setOpenFaildialog(true);
                setMessage("Write to parameter failed. Either no change in value or device/server is down");
                setSaveData(false);
                setOpen(false);
                setWriteLowInProgress(false);

              }else{
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(false);
                setOpenFaildialog(true);
                setMessage("Write to parameter failed. Either no change in value or device/server is down");
                setSaveData(false);
                setOpen(false);
                setWriteLowInProgress(false);

              }

            }

          } else if (responseData12?.WriteStatus === "InProgress") {

            // Keep polling flag true
            setWriteLowInProgress(true);

          } else {
            //Fallback safety
            setOpenInProgressdialog(false);
            setOpenSuccessDialog(false);
            setOpenFaildialog(true);
            setMessage("Unexpected response from server");
            setOpen(false);
            setWriteLowInProgress(false);
          }
        }
        else if(props.alarmConfigData.TagTypeLoLoSP !== 'SystemTag' && writeHiHiInProgress === false && writeHighInProgress === false && writeLowInProgress === false && writeLoLoInProgress === true)
        {
          const TagName = props.alarmConfigData.TagNameLoLoSP;
          let responseData12 = null;
          try {
            let response12 = await TableViewService.readTag(TagName);
            // Only 200 responses
            if (response12.status === 200 && response12.data) {
              responseData12 = response12.data; // object from
            }

          } catch (error) {
            // Any API error (500 / network) → treat as FAIL
            console.log("API Error:", error);

            responseData12 = {WriteStatus: "Fail"};
          }

          // Handle all cases centrally
          if (responseData12?.WriteStatus === "Success") {

            let auditTrailData = {
              EventStatus: props.writeData.EventStatus,
              ActivityType: 'Parameter Value Change',
              Remark: props.writeData.Remark,
              UserName: props.writeData.email,
              Role: props.writeData.role,
              TimeStamp: new Date(),
              Activity: `For parameter - ${props.alarmConfigData.TagNameLoLoSP} LoLo setpoint was modified from '${props.writeData.OldLoLoSP}' to '${responseData12.NewValue}'`
            };
            if(props.writeData.EventStatus === "Enabled"){
              let dashboardName = "AuditTrailLog";
              const response2 = await AuditTrailViewService.createRow(dashboardName, auditTrailData);
              if(response2){
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(true);
                setMessage("Parameter value updated Successfully");
                setSaveData(false);
                setOpen(false);
                setWriteLoLoInProgress(false);

              }

            }else{
              setOpenInProgressdialog(false);
              setOpenSuccessDialog(true);
              setMessage("Parameter value updated Successfully");
              setSaveData(false);
              setOpen(false);
              setWriteLoLoInProgress(false);

            }

          } else if (responseData12?.WriteStatus === "Fail") {

            // Covers BOTH Redis fail + API fail
            if(props.writeData.EventStatus === "Enabled"){

              let auditTrailData = {
                EventStatus: "Disabled",
                ActivityType: 'Parameter Value Change',
                Remark: props.writeData.Remark,
                UserName: props.writeData.email,
                Role: props.writeData.role,
                TimeStamp: new Date(),
                Activity: `For parameter - ${props.alarmConfigData.TagNameLoLoSP} LoLo setpoint modification failed.`
              };

              let dashboardName = "AuditTrailLog";
              const response2 = await AuditTrailViewService.createRow(dashboardName, auditTrailData);
              if(response2){
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(false);
                setOpenFaildialog(true);
                setMessage("Write to parameter failed. Either no change in value or device/server is down");
                setSaveData(false);
                setOpen(false);
                setWriteLoLoInProgress(false);

              }else{
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(false);
                setOpenFaildialog(true);
                setMessage("Write to parameter failed. Either no change in value or device/server is down");
                setSaveData(false);
                setOpen(false);
                setWriteLoLoInProgress(false);

              }

            }

          } else if (responseData12?.WriteStatus === "InProgress") {

            // Keep polling flag true
            setWriteLoLoInProgress(true);

          } else {
            //Fallback safety
            setOpenInProgressdialog(false);
            setOpenSuccessDialog(false);
            setOpenFaildialog(true);
            setMessage("Unexpected response from server");
            setOpen(false);
            setWriteLoLoInProgress(false);
          }
        }

        ////////////////////////////////////////////////////////////////
       
        // If system tags is assigned to process value
        if(props.tagDetails.TagType === 'SystemTag' && writeInProgress === true){
          let dashboardName1 = "TagList";
          let writeData = {
            TagName: props.writeData.TagName,
            OldValue: props.writeData.OldProcessValue,
            NewValue: props.writeData.ProcessValue,
            PWDInterlock: props.writeData.PWDInterlock,
            PWD: password,
            WriteStatus: "InProgress",
            email: props.writeData.email,
            role: props.writeData.role
          }
          //console.log(writeData)
          const response1 = await TableViewService.updateTag(dashboardName1, writeData);
          if(response1){
            //console.log(response1.data);
            let auditTrailData = {'EventStatus':props.writeData.EventStatus, 'ActivityType':'Parameter Value Change', 'Remark':props.writeData.Remark,
              'UserName':props.writeData.email, 'Role': props.writeData.role, 'TimeStamp': new Date(),
              'Activity': `For parameter - ${props.writeData.TagName} parameter value was modified from '${props.writeData.OldProcessValue}' to '${props.writeData.processValue}'`
            };
            //console.log(auditTrailData)
            //Check audittrail log is enabled or not
            if(props.writeData.EventStatus === "Enabled"){
              let dashboardName3 = "AuditTrailLog";
              const response2 = await AuditTrailViewService.createRow(dashboardName3, auditTrailData);
              if(response2){
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(true);
                setMessage("Parameter value updated Successfully");
                setOpen(false); // Close "Save changes" window

                setWriteInProgress(false);
                setSaveData(false);

              }

            }else{
              setOpenInProgressdialog(false);
              setOpenSuccessDialog(true);
              setMessage("Parameter value updated Successfully");
              setOpen(false); // Close "Save changes" window

              setWriteInProgress(false);
              setSaveData(false);

            }

          }else{
            setOpenInProgressdialog(true);
            setMessage("Device Parameter value writing is in progress, please wait...");
  
          }


        }

        // If system tags are assigned to alarm setpoint
        if(props.alarmConfigData.TagTypeHiHiSP === 'SystemTag' && writeHiHiInProgress === true){
          let dashboardName1 = "TagList";
          let writeData = {
            TagName: props.alarmConfigData.TagNameHiHiSP,
            OldValue: props.alarmConfigData.OldHiHiSP,
            NewValue: props.writeData.HiHiSP,
            PWDInterlock: props.writeData.PWDInterlock,
            PWD: password,
            WriteStatus: "InProgress",
            email: props.writeData.email,
            role: props.writeData.role
          }

          const response1 = await TableViewService.updateTag(dashboardName1, writeData);
          if(response1){
            //console.log(response1.data);
            let auditTrailData = {'EventStatus':props.writeData.EventStatus, 'ActivityType':'Parameter Value Change', 'Remark':props.writeData.Remark,
              'UserName':props.writeData.email, 'Role': props.writeData.role, 'TimeStamp': new Date(),
              'Activity': `For parameter - ${props.alarmConfigData.TagName} HiHi setpoint was modified from '${props.writeData.OldHiHiSP}' to '${props.writeData.HiHiSP}'`
            };
            //console.log(auditTrailData)
            //Check audittrail log is enabled or not
            if(props.writeData.EventStatus === "Enabled"){
              let dashboardName3 = "AuditTrailLog";
              const response2 = await AuditTrailViewService.createRow(dashboardName3, auditTrailData);
              if(response2){
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(true);
                setMessage("Parameter value updated Successfully");
                setOpen(false); // Close "Save changes" window

                setWriteHiHiInProgress(false);
                setSaveData(false);

              }

            }else{
              setOpenInProgressdialog(false);
              setOpenSuccessDialog(true);
              setMessage("Parameter value updated Successfully");
              setOpen(false); // Close "Save changes" window

              setWriteHiHiInProgress(false);
              setSaveData(false);

            }

          }else{
            setOpenInProgressdialog(true);
            setMessage("Device Parameter value writing is in progress, please wait...");
  
          }

        }
        if(writeHiHiInProgress === false && props.alarmConfigData.TagTypeHighSP === 'SystemTag' && writeHighInProgress === true){
          
          let dashboardName1 = "TagList";
          let writeData = {
            TagName: props.alarmConfigData.TagNameHighSP,
            OldValue: props.alarmConfigData.OldHighSP,
            NewValue: props.writeData.HighSP,
            PWDInterlock: props.writeData.PWDInterlock,
            PWD: password,
            WriteStatus: "InProgress",
            email: props.writeData.email,
            role: props.writeData.role
          }

          const response1 = await TableViewService.updateTag(dashboardName1, writeData);
          if(response1){
            //console.log(response1.data);
            let auditTrailData = {'EventStatus':props.writeData.EventStatus, 'ActivityType':'Parameter Value Change', 'Remark':props.writeData.Remark,
              'UserName':props.writeData.email, 'Role': props.writeData.role, 'TimeStamp': new Date(),
              'Activity': `For parameter - ${props.alarmConfigData.TagName} High setpoint was modified from '${props.writeData.OldHighSP}' to '${props.writeData.HighSP}'`
            };
            //console.log(auditTrailData)
            //Check audittrail log is enabled or not
            if(props.writeData.EventStatus === "Enabled"){
              let dashboardName3 = "AuditTrailLog";
              const response2 = await AuditTrailViewService.createRow(dashboardName3, auditTrailData);
              if(response2){
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(true);
                setMessage("Parameter value updated Successfully");
                setOpen(false); // Close "Save changes" window

                setWriteHighInProgress(false);
                setSaveData(false);

              }

            }else{
              setOpenInProgressdialog(false);
              setOpenSuccessDialog(true);
              setMessage("Parameter value updated Successfully");
              setOpen(false); // Close "Save changes" window

              setWriteHighInProgress(false);
              setSaveData(false);

            }

          }else{
            setOpenInProgressdialog(true);
            setMessage("Device Parameter value writing is in progress, please wait...");
  
          }
  
        }
        if(writeHighInProgress === false && props.alarmConfigData.TagTypeLowSP === 'SystemTag' && writeLowInProgress === true){
          let dashboardName1 = "TagList";
          
          let writeData = {
            TagName: props.alarmConfigData.TagNameLowSP,
            OldValue: props.alarmConfigData.OldLowSP,
            NewValue: props.writeData.LowSP,
            PWDInterlock: props.writeData.PWDInterlock,
            PWD: password,
            WriteStatus: "InProgress",
            email: props.writeData.email,
            role: props.writeData.role
          }

          const response1 = await TableViewService.updateTag(dashboardName1, writeData);
          if(response1){
            //console.log(response1.data);
            let auditTrailData = {'EventStatus':props.writeData.EventStatus, 'ActivityType':'Parameter Value Change', 'Remark':props.writeData.Remark,
              'UserName':props.writeData.email, 'Role': props.writeData.role, 'TimeStamp': new Date(),
              'Activity': `For parameter - ${props.alarmConfigData.TagName} Low setpoint was modified from '${props.writeData.OldLowSP}' to '${props.writeData.LowSP}'`
            };
            //console.log(auditTrailData)
            //Check audittrail log is enabled or not
            if(props.writeData.EventStatus === "Enabled"){
              let dashboardName3 = "AuditTrailLog";
              const response2 = await AuditTrailViewService.createRow(dashboardName3, auditTrailData);
              if(response2){
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(true);
                setMessage("Parameter value updated Successfully");
                setOpen(false); // Close "Save changes" window

                setWriteLowInProgress(false);
                setSaveData(false);

              }

            }else{
              setOpenInProgressdialog(false);
              setOpenSuccessDialog(true);
              setMessage("Parameter value updated Successfully");
              setOpen(false); // Close "Save changes" window

              setWriteLowInProgress(false);
              setSaveData(false);

            }

          }else{
            setOpenInProgressdialog(true);
            setMessage("Device Parameter value writing is in progress, please wait...");
  
          }
          
          
        }
        if(writeLowInProgress === false && props.alarmConfigData.TagTypeLoLoSP === 'SystemTag' && writeLoLoInProgress === true){
          let dashboardName1 = "TagList";
          let writeData = {
            TagName: props.alarmConfigData.TagNameLoLoSP,
            OldValue: props.alarmConfigData.OldLoLoSP,
            NewValue: props.writeData.LoLoSP,
            PWDInterlock: props.writeData.PWDInterlock,
            PWD: password,
            WriteStatus: "InProgress",
            email: props.writeData.email,
            role: props.writeData.role
          }

          const response1 = await TableViewService.updateTag(dashboardName1, writeData);
          if(response1){
            //console.log(response1.data);
            let auditTrailData = {'EventStatus':props.writeData.EventStatus, 'ActivityType':'Parameter Value Change', 'Remark':props.writeData.Remark,
              'UserName':props.writeData.email, 'Role': props.writeData.role, 'TimeStamp': new Date(),
              'Activity': `For parameter - ${props.alarmConfigData.TagName} LoLo setpoint was modified from '${props.writeData.OldLoLoSP}' to '${props.writeData.LoLoSP}'`
            };
            //console.log(auditTrailData)
            //Check audittrail log is enabled or not
            if(props.writeData.EventStatus === "Enabled"){
              let dashboardName3 = "AuditTrailLog";
              const response2 = await AuditTrailViewService.createRow(dashboardName3, auditTrailData);
              if(response2){
                setOpenInProgressdialog(false);
                setOpenSuccessDialog(true);
                setMessage("Parameter value updated Successfully");
                setOpen(false); // Close "Save changes" window

                setWriteLoLoInProgress(false);
                setSaveData(false);

              }

            }else{
              setOpenInProgressdialog(false);
              setOpenSuccessDialog(true);
              setMessage("Parameter value updated Successfully");
              setOpen(false); // Close "Save changes" window

              setWriteLoLoInProgress(false);
              setSaveData(false);

            }

          }else{
            setOpenInProgressdialog(true);
            setMessage("Device Parameter value writing is in progress, please wait...");
  
          }
          
        }


      }catch(error){
        

        if (isMounted.current) { // Ensure component is mounted before updating state
          setWriteInProgress(false)
          setWriteHiHiInProgress(false)
          setWriteHighInProgress(false)
          setWriteLowInProgress(false)
          setWriteLoLoInProgress(false)
          setReadRequest(false)
          setOpenInProgressdialog(false)

          setOpenFaildialog(true);
          setMessage("Error occured while read/write of the alarm setpoints.");
          setOpen(false); // Close "Save changes" window
        }
        console.error(error);
      }
      

    };
    if(ReadRequest === true){
      readWriteConfigCollection();
      setReadRequest(false);
    };
  }, [ReadRequest]);

  //Check perodically
  useEffect(() =>{
    const intervalId = setInterval(() => {
      if((writeInProgress === true || writeHiHiInProgress === true || writeHighInProgress === true || writeLowInProgress === true || writeLoLoInProgress === true) && ReadRequest === false){
        //console.log(props.tagType)
        //setOpenInProgressdialog(true);
        //setMessage("Parameter value writing is in progress, please wait...");
        setReadRequest(true);
        

      }
    },1000);
    // Clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [writeInProgress, writeHiHiInProgress, writeHighInProgress, writeLowInProgress, writeLoLoInProgress]);

  // As per tagType, update WriteConfig collection to set alarm SP values OR update system tag PV value 
  useEffect(() =>{
    async function saveRowData()  {
    try {
      // Single Write, If writing Tag rather than setpoints
      if((props.writeData.WriteType === "PVAnalog") || (props.writeData.WriteType === "PVDigital") || (props.writeData.WriteType === "PVString")){
        //If device tag is assigned to PV tag
        if(props.tagDetails.TagType !== 'SystemTag'){
          let dashboardName1 = "TagList";
          let writeData = {
            TagName: props.writeData.TagName,
            OldValue: props.writeData.OldProcessValue,
            NewValue: props.writeData.ProcessValue,
            PWDInterlock: props.writeData.PWDInterlock,
            PWD: password,
            WriteStatus: "InProgress",
            email: props.writeData.email,
            role: props.writeData.role
          }

          const response1 = await TableViewService.updateTag(dashboardName1, writeData);
          if(response1){
            setWriteInProgress(true);
            setOpenInProgressdialog(true);
            setMessage("Parameter value writing is in progress, please wait...");
              
          }
           
        }

        //If system tag is assigned for HiHi alarm tag
        if(props.tagDetails.TagType === 'SystemTag'){
          setWriteInProgress(true);
          setOpenInProgressdialog(true);
          setMessage("Parameter value writing is in progress, please wait...");
                      
        }
      }

      // MultiWrite setpoints writing
      if(props.writeData.WriteType === "SPAnalog"){

        //If device tag is assigned for HiHi alarm tag
        if(props.alarmConfigData.TagTypeHiHiSP !== 'SystemTag' && (props.writeData.OldHiHiSP !== props.writeData.HiHiSP)){
          let dashboardName1 = "TagList";
          let writeData = {
            TagName: props.alarmConfigData.TagNameHiHiSP,
            OldValue: props.writeData.OldHiHiSP,
            NewValue: props.writeData.HiHiSP,
            PWDInterlock: props.writeData.PWDInterlock,
            PWD: password,
            WriteStatus: "InProgress",
            email: props.writeData.email,
            role: props.writeData.role
          }

          const response1 = await TableViewService.updateTag(dashboardName1, writeData);
          if(response1){
            setWriteHiHiInProgress(true);
            setOpenInProgressdialog(true);
            setMessage("Parameter value writing is in progress, please wait...");
              
          }
            
        }
        
        if(props.alarmConfigData.TagTypeHighSP!== 'SystemTag' && (props.writeData.OldHighSP !== props.writeData.HighSP)){
          let dashboardName1 = "TagList";
          let writeData = {
            TagName: props.alarmConfigData.TagNameHighSP,
            OldValue: props.writeData.OldHighS,
            NewValue: props.writeData.HighSP,
            PWDInterlock: props.writeData.PWDInterlock,
            PWD: password,
            WriteStatus: "InProgress",
            email: props.writeData.email,
            role: props.writeData.role
          }

          const response1 = await TableViewService.updateTag(dashboardName1, writeData);
          if(response1){
            setWriteHighInProgress(true);
            setOpenInProgressdialog(true);
            setMessage("Parameter value writing is in progress, please wait...");
              
          }
           
        }
        
        if(props.alarmConfigData.TagTypeLowSP !== 'SystemTag' && (props.writeData.OldLowSP !== props.writeData.LowSP)){
          let dashboardName1 = "TagList";
          let writeData = {
            TagName: props.alarmConfigData.TagNameLowSP,
            OldValue: props.writeData.OldLowSP,
            NewValue: props.writeData.LowSP,
            PWDInterlock: props.writeData.PWDInterlock,
            PWD: password,
            WriteStatus: "InProgress",
            email: props.writeData.email,
            role: props.writeData.role
          }

          const response1 = await TableViewService.updateTag(dashboardName1, writeData);
          if(response1){
            setWriteLowInProgress(true);
            setOpenInProgressdialog(true);
            setMessage("Parameter value writing is in progress, please wait...");
              
          }
           
        }
        
        if(props.alarmConfigData.TagTypeLoLoSP !== 'SystemTag' && (props.writeData.OldLoLoSP !== props.writeData.LoLoSP)){
          let dashboardName1 = "TagList";
          let writeData = {
            TagName: props.alarmConfigData.TagNameLoLoSP,
            OldValue: props.writeData.OldLoLoSP,
            NewValue: props.writeData.LoLoSP,
            PWDInterlock: props.writeData.PWDInterlock,
            PWD: password,
            WriteStatus: "InProgress",
            email: props.writeData.email,
            role: props.writeData.role
          }

          const response1 = await TableViewService.updateTag(dashboardName1, writeData);
          if(response1){
            setWriteLoLoInProgress(true);
            setOpenInProgressdialog(true);
            setMessage("Parameter value writing is in progress, please wait...");
              
          }
           
        }


        //If system tag is assigned for HiHi alarm tag
        if(props.alarmConfigData.TagTypeHiHiSP === 'SystemTag' && (props.writeData.OldHiHiSP !== props.writeData.HiHiSP)){
          setWriteHiHiInProgress(true);
          setOpenInProgressdialog(true);
          setMessage("Parameter value writing is in progress, please wait...");
                      
        }

        //If device tag is not assigned for High alarm tag
        if(props.alarmConfigData.TagTypeHighSP === 'SystemTag' && (props.writeData.OldHighSP !== props.writeData.HighSP)){
          
          setWriteHighInProgress(true);
          setOpenInProgressdialog(true);
          setMessage("Parameter value writing is in progress, please wait...");
          
        }

        //If device tag is not assigned for Low alarm tag
        if(props.alarmConfigData.TagTypeLowSP === 'SystemTag' && (props.writeData.OldLowSP !== props.writeData.LowSP)){
        
          setWriteLowInProgress(true);
          setOpenInProgressdialog(true);
          setMessage("Parameter value writing is in progress, please wait...");
          
        }

        //If device tag is not assigned for LoLo alarm tag
        if(props.alarmConfigData.TagTypeLoLoSP === 'SystemTag' && (props.writeData.OldLoLoSP !== props.writeData.LoLoSP)){
        
          setWriteLoLoInProgress(true);
          setOpenInProgressdialog(true);
          setMessage("Parameter value writing is in progress, please wait...");
          
        }
        
      }

    } catch (error) {
      setOpenInProgressdialog(false);
      setOpenSuccessDialog(false);
      setOpenFaildialog(true);
      setMessage("Error While Adding Record, Please very all parameters, password entered in form or server is down ");
      setOpen(false); // Close "Save changes" window
      //console.log(error);


    }
  };
  if(saveData){
    
    saveRowData();
    setSaveData(false);
  };


  }, [saveData]);
  
  // Check Remark and value change happened or not, then after only proceeed to open dialog of save changes
  const handleClickOpen = () => {
    // If remark field is blank then opern messagebox
    if(((props.writeData.RemarkStatus === "Enabled") && (props.writeData.Remark === "--")) || ((props.writeData.RemarkStatus === "Enabled") && (props.writeData.Remark === ""))){
      setOpenRemarkBlnkMsg(true);
    }else{
      if((props.writeData.WriteType === "PVAnalog") || (props.writeData.WriteType === "PVDigital") || (props.writeData.WriteType === "PVString")){
        //If no value change observed for Process value then open message box
        if(props.writeData.ProcessValue === props.writeData.OldProcessValue){
          setOpenInProgressdialog(false);
          setOpenSuccessDialog(false);
          setOpenFaildialog(true);
          setMessage("There is no change observed in parameter value.");
          setOpen(false); // Close "Save changes" window

        }else{
          //If remoark is entered and value change observed then proceed
          setOpen(true);    
        }
      }

      if(props.writeData.WriteType === "SPAnalog"){
        //If no value change observed for Process value then open message box
        if((props.writeData.OldHiHiSP === props.writeData.HiHiSP) && (props.writeData.OldHighSP === props.writeData.HighSP) && (props.writeData.OldLowSP === props.writeData.LowSP) && (props.writeData.OldLoLoSP === props.writeData.LoLoSP)){
          setOpenInProgressdialog(false);
          setOpenSuccessDialog(false);
          setOpenFaildialog(true);
          setMessage("There is no change observed in parameter value.");
          setOpen(false); // Close "Save changes" window

        }else{
          //If remoark is entered and value change observed then proceed
          setOpen(true); 
        }



      }

    
    }
    

  }

  return (
    
    <div>
      <Button variant="outlined" startIcon ={<SaveIcon/>} sx={{mt:1}} onClick={handleClickOpen}>SAVE CHANGES </Button>

      {/* Open Remark Field is blank dialog box */}
      <Dialog open={openRemarkBlnkMsg} onClose={handleClose}>
        <DialogTitle>Enter Remark Field</DialogTitle>
        <Box sx={{width: 450 }}>
        <DialogContent dividers>
          <DialogContentText>
              Enter Remark into remark field to proceed further.
              <br />
              (Note: blank or '--' Value for remark field is not acceptable)
          </DialogContentText>
          
        </DialogContent>
        </Box>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Open Confirmation dialog box with or without password entry */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Save changes in value of parameter</DialogTitle>
        <Box sx={{width: 400 }}>
          <DialogContent dividers>
            <DialogContentText>
              Are you sure to update the Changes?.
            </DialogContentText>
            
          </DialogContent>

          {props.writeData.PWDInterlock === 'Enabled' && (<DialogContent dividers>
            <DialogContentText>
              Enter the Password to make changes in parameter value.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="Password"
              label="Password"
              type="password"
              fullWidth
              variant="standard"
              onChange={(event) => {
                setPassword(event.target.value);
              }}
            />

          </DialogContent>
          )}

        </Box>
        <DialogActions>
          <Button onClick={handleClickSaveChanges}>Save</Button>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Open wrong value enetered dialog box*/}
      <Dialog open={wrongValue} onClose={handleClose}>
        <DialogTitle>Wrong Value</DialogTitle>
        <Box sx={{width: 400 }}>
        <DialogContent dividers>
          <DialogContentText>
            Wrong Value or data entered. Please Correct it.
          </DialogContentText>
          
        </DialogContent>
        </Box>
        <DialogActions>
          <Button onClick={handleClose}>ok</Button>
        </DialogActions>
      </Dialog>

      {/* Success dialog after upgradtion of the parameter */}
      <Dialog
        open={openSuccessDialog}
        onClose={handleSuccessClose}
       
      >
        <DialogTitle > success.. </DialogTitle>
        <DialogContent>
          <DialogContentText>
            { message } 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSuccessClose}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Save Changes in progress dialog  */}
      <Dialog
        open={openInProgressdialog}
        onClose={handleInProgressClose}
       
      >
        <DialogTitle > In Progress.. </DialogTitle>
        <DialogContent>
          <DialogContentText>
            { message } 
          </DialogContentText>
        </DialogContent>
       
      </Dialog>

      {/* Save Changes Failed dialog /Wrong Password */}
      <Dialog
        open={openFaildialog}
        onClose={handleFailedClose}
       
      >
        <DialogTitle > Failed.. </DialogTitle>
        <DialogContent>
          <DialogContentText>
            { message } 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFailedClose}>Close</Button>
        </DialogActions>
      </Dialog>


    </div>
  );
}


export default function DashboardEdit ({params, open, close}) {
  //console.log(params)
  const { user } = useSelector((state) => state.auth);

  const initialAlarmConfigData = {
    AddrTypeDigAlarm: "RegAddr",
    AddrTypeHiHiAlarm: "RegAddr",
    AddrTypeHighAlarm: "RegAddr",
    AddrTypeLoLoAlarm: "RegAddr",
    AddrTypeLowAlarm: "RegAddr",
    AlarmAcknowledgement: "Enabled",
    AlarmCatagory: "AnalogAlarm",
    AlarmDelay: "0",
    AlarmEmail: "Enabled",
    AlarmHiHi: "0",
    AlarmHigh: "0",
    AlarmHysterisis: "0",
    AlarmInRange: "Enabled",
    AlarmInRangeDescription:"Normal",
    AlarmLoLo: "0",
    AlarmLow: "0",
    AlarmName: "Alarm1",
    AlarmSMS: "Enabled",
    AlarmStatus: "Enabled",
    AlarmType: "SoftAlarm",
    BitAddresDigAlarm: "0",
    BitAddresHiHiAlarm: "0",
    BitAddresHighAlarm: "0",
    BitAddresLoLoAlarm: "0",
    BitAddresLowAlarm: "0",
    BlockName: "topic1",
    BlockNameDigAlarm: "NA",
    BlockNameHiHiAlarm: "NA",
    BlockNameHiHiSP: "NA",
    BlockNameHighAlarm: "NA",
    BlockNameHighSP: "NA",
    BlockNameLoLoAlarm: "NA",
    BlockNameLoLoSP: "NA",
    BlockNameLowAlarm: "NA",
    BlockNameLowSP: "NA",
    ConcatPVInAlarm: "Enabled",
    ConcatSPInAlarm: "Enabled",
    DigAlarm: "0",
    DigAlarmDescription: "Faulty",
    DigAlarmLogEnable: "Enabled",
    DigAlarmTrigCond: "1",
    HiHiAlarmDescription: "Alarm High High",
    HiHiEnable: "Disabled",
    HiHiLogEnable: "Enabled",
    HiHiSP: "90",
    HighAlarmDescription: "Alarm High",
    HighEnable: "Disabled",
    HighLogEnable: "Enabled",
    HighSP: "80",
    LoLoAlarmDescription: "Alarm Low Low",
    LoLoEnable: "Disabled",
    LoLoLogEnable: "Enabled",
    LoLoSP: "20",
    LowAlarmDescription: "Alarm Low",
    LowEnable: "Disabled",
    LowLogEnable: "Enabled",
    LowSP: "30",
    PresentAlarmStatus: "Alarm",
    TagName: "FLOWRATE",
    TagNameDigAlarm: "NA",
    TagNameHiHiAlarm: "NA",
    TagNameHiHiSP: "NA",
    TagNameHighAlarm: "NA",
    TagNameHighSP: "NA",
    TagNameLoLoAlarm: "NA",
    TagNameLoLoSP: "NA",
    TagNameLowAlarm: "NA",
    TagNameLowSP: "NA",
    TagQuality: "bad",
    TagType: "MqttTag",
    TagTypeDigAlarm: "ModbusTag",
    TagTypeHiHiAlarm: "ModbusTag",
    TagTypeHiHiSP: "ModbusTag",
    TagTypeHighAlarm: "ModbusTag",
    TagTypeHighSP: "ModbusTag",
    TagTypeLoLoAlarm: "ModbusTag",
    TagTypeLoLoSP: "ModbusTag",
    TagTypeLowAlarm: "ModbusTag",
    TagTypeLowSP: "ModbusTag",
    TagValue: "0",
  }

  const initialTagDetails = {
    TagName: params.row.TagName,
    ProcessValue: params.row.ProcessValue,
    TagType:"SystemTag",
    TagCatagory:"String",
    DataType:"Integer",
    OnLabel:"ON",
    OffLabel:"OFF", 
    DisplayWidth:5,
    ExponentDigit:2,
    FunctionCode:"0",
  };

  const initialWriteData = {
    _id:params.row.id,
    TagName: params.row.TagName,
    OldProcessValue: params.row.ProcessValue,
    ProcessValue: params.row.ProcessValue,
    OldHiHiSP:params.row.HiHiSP,
    HiHiSP:params.row.HiHiSP,
    OldHighSP:params.row.HighSP,
    HighSP:params.row.HighSP,
    OldLowSP:params.row.LowSP, 
    LowSP:params.row.LowSP,
    OldLoLoSP:params.row.LoLoSP,
    LoLoSP:params.row.LoLoSP,
    WriteType:"SPAnalog",
    
    role:user.role,
    email: user.email,  
    RemarkStatus : "Disabled",
    Remark:"",
    EventStatus:"Disabled",
    PWDInterlock:"Disabled",
    PWD:""

  };

  const [alarmConfigData, setAlarmConfigData] = useState(initialAlarmConfigData);
  const [tagDetails, setTagDetails] = useState(initialTagDetails);
  const [writeData, setWriteData] = React.useState(initialWriteData);

  const [selectedOption, setSelectedOption] = useState('');
  const showOptionDropDown =
  alarmConfigData.HiHiEnable === 'Enabled' ||
  alarmConfigData.HighEnable === 'Enabled' ||
  alarmConfigData.LowEnable === 'Enabled' ||
  alarmConfigData.LoLoEnable === 'Enabled';
  // DropDown Options
  const options = [
    { value: 'HiHiSP', label: 'HiHi Setpoint', visible: alarmConfigData.HiHiEnable === 'Enabled'},
    { value: 'HighSP', label: 'High Setpoint', visible: alarmConfigData.HighEnable === 'Enabled'},
    { value: 'LowSP', label: 'Low Setpoint', visible: alarmConfigData.LowEnable === 'Enabled'},
    { value: 'LoLoSP', label: 'LoLo Setpoint', visible: alarmConfigData.LoLoEnable === 'Enabled'},
  ];

  const[processValue, setProcessValue] = React.useState(params.row.ProcessValue);
  const[alarmSetpoint, setAlarmSetpoint] = React.useState('');

  // Get AuditTrail Configuration data for Remark field, either it is enabled or disabled
  useEffect(() =>{
    async function auditTrailConfigData()  {
    try {

      let dashboardName = 'AuditTrailConfig';
      let columnName = 'EventName';
      let columnValue = 'Setpoint Change';
      let response = await AuditTrailViewService.getColumnData(dashboardName, columnName, columnValue);

      
      if(response.data.length > 0){
        //console.log(response.data[0]);
        setWriteData(prev => ({
          ...prev,
          RemarkStatus:response.data[0].EnableRemark, 
          EventStatus: response.data[0].EnableEvent, 
          PWDInterlock: response.data[0].EnablePwdInterlock
        }));
      }
  
    } catch (error) {
      console.log(error);

    }
  }

  auditTrailConfigData();

  }, []);

  // Get alarmCongig data for specific tagname
  useEffect(() =>{
    async function getAlarmConfigtData()  {
    try {

      let dashboardName = "AlarmConfig"
      let columnName = 'TagName'
      let columnValue = params.row.TagName

      const response = await ConfigurationViewService.getColumnData(dashboardName, columnName, columnValue);
      if (response.data.length > 0) {
        //console.log(response.data[0])
        setAlarmConfigData(response.data[0])

      }

  
    } catch (error) {
      console.log(error);

    }
  }
  getAlarmConfigtData();

  }, []);

  // Get tag details from TagList Collection
  useEffect(() =>{
    async function getModbusTagListData()  {
    try {

      let dashboardName = "TagList";
      let columnsToRetrieve = ["_id", "FunctionCode", "DataType", "TagType", "TagCatagory", "TagName", "Processvalue",  "OnLabel" , "OffLabel", "DisplayWidth", "ExponentDigit" ];
      let columnToFilter ="TagName";
      let valueToMatch = params.row.TagName;

      
      const response = await TableViewService.getMultiColumnsRows(dashboardName, columnsToRetrieve, columnToFilter, valueToMatch );
      //console.log(response.data[0]);
      if(response.data.length > 0){
        setTagDetails(response.data[0]);
        //setWriteData({...writeData, '_id':response.data[0]._id});
        setWriteData(prev => ({
          ...prev,
          _id: response.data[0]._id
        }));
      }
  
    } catch (error) {
      console.log(error);

    }
  }
  getModbusTagListData();

  }, []);

  const handleSelectFieldChange = (event) =>{
    const {name, value} = event.target;
    setSelectedOption(value);
    if(value === 'HiHiSP'){
      setAlarmSetpoint(writeData.HiHiSP);
    }
    if(value === 'HighSP'){
      setAlarmSetpoint(writeData.HighSP);
    }
    if(value === 'LowSP'){
      setAlarmSetpoint(writeData.LowSP);
    }
    if(value === 'LoLoSP'){
      setAlarmSetpoint(writeData.LoLoSP);
    }

  }

  const handleSetpointValueChange = (event) => {
    const {name, value} = event.target;

     //   /^\d*\.?\d{0,7}$/.test(value))
    const regex = new RegExp( `^-?\\d{0,${tagDetails.DisplayWidth}}(?:\\.\\d{0,${tagDetails.ExponentDigit}})?$` );

    // Validate input against the dynamic regex
    if (regex.test(value)) {
      setAlarmSetpoint(value);
      
      if(selectedOption === 'HiHiSP'){
        setWriteData({...writeData, 'HiHiSP':value, 'WriteType':"SPAnalog"});
      };
      if(selectedOption=== 'HighSP'){
        setWriteData({...writeData, 'HighSP':value, 'WriteType':"SPAnalog"});
      };
      if(selectedOption === 'LoLoSP'){
        setWriteData({...writeData, 'LoLoSP':value, 'WriteType':"SPAnalog"});
      };
      if(selectedOption === 'LowSP'){
        setWriteData({...writeData, 'LowSP':value, 'WriteType':"SPAnalog"});
      };
    }

  };

  const handleProcessValueChange = (event) =>{
    const {name, value} = event.target;

    const regex = new RegExp( `^-?\\d{0,${tagDetails.DisplayWidth}}(?:\\.\\d{0,${tagDetails.ExponentDigit}})?$` );
    // If Process value field provide number then 
    if(tagDetails.TagCatagory === 'Analog'){
      if(regex.test(value)){
        setProcessValue(value);
        setWriteData({...writeData, [name]:value, 'WriteType':"PVAnalog"});
      }  

    }
    if(tagDetails.TagCatagory === 'Digital'){
      // Write 0 or 1
      setProcessValue(value);
      if(value === tagDetails.OnLabel){

        setWriteData({...writeData, [name]:'1', 'WriteType':"PVDigital"});

      }
      if(value === tagDetails.OffLabel){

        setWriteData({...writeData, [name]:'0', 'WriteType':"PVDigital"});

      }
      //setWriteData({...writeData, [name]:value, 'ProcessValue': 1});


    }
    if(tagDetails.TagCatagory === 'String'){
      setProcessValue(value);
      setWriteData({...writeData, [name]:value, 'WriteType':"PVString"});
    }

  }

  const handleRemarkChange = (event) => {
    const {name, value} = event.target;
    setWriteData({...writeData, [name]:value});

  };

  const handleClose = () => {
    //console.log("Close Buton Pressed");
    close() // Close the alarm add main window
  };

  const handleRecordSaveSuccess = (data) =>{
    close(data)
  }
  
  return (
    <div>
      <BootstrapDialog
        onClose={close}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          style: {
            maxWidth: '1000px', // Change this value as needed
          },
        }}
      >
        {/* Hnadle multiple functions on single click ie edit switch set to false and close the MyAccount Dialog */}
        <BootstrapDialogTitle id="customized-dialog-title" onClose={() => {handleClose();  }}>
          Edit parameter value.
        </BootstrapDialogTitle>

        {/*Setpoint Changes*/}
        <DialogContent dividers>
          {/*
          <Typography gutterBottom sx={{ mt: 0, mb:3, width: 200 }}>
          {params.row.TagDescription1}
          </Typography>
          */}

          {/* TagName */}
          <TextField
            sx={{ m: 0, width: 200, mt: 1, mr:2, }}
            margin="dense"
            label="Parameter Name"
            //type="number"
            //fullWidth
            variant="standard"
            name="TagName"
            value={params.row.TagName}
            disabled={true}
          />

          {/* Alarmsetpoint Dropdown and TextBox for writing the vlaue */}
          {tagDetails.TagCatagory !== 'Digital' && showOptionDropDown &&(
          <>
            <FormControl sx={{ m: 0, width: 200, mt: 1, mr:2, }} variant="standard" margin="dense">
              <InputLabel id="dropdown-label">Edit Options</InputLabel>
              <Select
                labelId="dropdown-label"
                value={selectedOption}
                onChange={handleSelectFieldChange}
                label="Options"
                disabled={false}
              >
                {options
                  .filter((opt) => opt.visible)
                  .map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

            <TextField
              margin="dense"
              label="Set Value"
              //type="number"
              //fullWidth
              variant="standard"
              name="AlarmSetpoint"
              value={alarmSetpoint}
              onChange={handleSetpointValueChange}
              disabled={false}
            />
          </>
          )}

          {/* ProcessValue change for analog or string tag */}
          {(!showOptionDropDown && tagDetails.TagCatagory !== 'Digital')&&(
            <TextField
              margin="dense"
              label="Set Value"
              //type="number"
              //fullWidth
              variant="standard"
              name="ProcessValue"
              value={processValue}
              onChange={ handleProcessValueChange}
              disabled={false}
            />

          )}

          {/* ProcessValue change for digital tag */}
          {(tagDetails.TagCatagory === 'Digital') && (
          <FormControl sx={{ m: 0, width: 200, mt: 1, mr:2, }} variant="standard">
            <InputLabel id="demo-customized-select-label">Process Value</InputLabel>
            <Select
            autoFocus
            variant="standard"
            name="ProcessValue"
            value={processValue}
            onChange={handleProcessValueChange}
            disabled={false}
            //input={<BootstrapInput />}
            >
            <MenuItem value={tagDetails.OnLabel}>{tagDetails.OnLabel}</MenuItem>
            <MenuItem value={tagDetails.OffLabel}>{tagDetails.OffLabel}</MenuItem>
            </Select>
          </FormControl>
          )}

          
        </DialogContent>

        {/*Remark */}
        {writeData.RemarkStatus === 'Enabled' && (<DialogContent 
        dividers
        >
          <Typography gutterBottom sx={{ mt: 0, mb:3, width: 400 }}>
          Enter remark for parameter value change 
          </Typography>

          <TextField
            id="outlined-multiline-static"
            label="Remark"
            name="Remark"
            placeholder="Enter Remark"
            multiline
            rows={4}
            style={{ width: 400 }}
            onChange={handleRemarkChange}
            //defaultValue="Default Value"
          />

        </DialogContent>
        )}

        <DialogActions>
          <SaveChangesDialog
          alarmConfigData = {alarmConfigData}
          tagDetails = {tagDetails}
          writeData = {writeData}

          success = {handleRecordSaveSuccess}
          />
        </DialogActions>
        
      </BootstrapDialog>
    </div>
  );
}



